<template>
  <div class="col-md-12 sim-task_list">

    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="form_select">
          <tree-select
              :options="target_list"
              :multiple="false"
              v-model="filter.target_result"
              :placeholder="translate('sim_task_list.task_list.target_result')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <tree-select
              :options="status_list"
              :multiple="false"
              v-model="filter.status"
              :placeholder="translate('sim_task_list.task_list.status')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select"></div>
        <div class="form_select"></div>
        <div class="form_select"></div>

        <span
            class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
            @click.prevent="create_sim_task"
        >
          <b>{{ translate('sim_task_list.task_list.create_sim_task') }}</b>
        </span>
      </div>
    </div>

    <div class="response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col">
              {{ translate('sim_task_list.task_list.name') }}
            </th>
            <th scope="col">
              {{ translate('sim_task_list.task_list.target_result') }}
            </th>
            <th scope="col">
              {{ translate('sim_task_list.task_list.status') }}
            </th>
            <th scope="col">
              {{ translate('sim_task_list.task_list.source') }}
            </th>
            <th scope="col">
              {{ translate('sim_task_list.task_list.priority') }}
            </th>
            <th scope="col" class="w7per">
              {{ translate('sim_task_list.task_list.items_count') }}
            </th>
            <th scope="col" class="w7per">
              {{ translate('sim_task_list.task_list.started_at') }}
            </th>
            <th scope="col" class="w7per">
              {{ translate('sim_task_list.task_list.finished_at') }}
            </th>
            <th scope="col" class="w7per">
              {{ translate('sim_task_list.task_list.created_at') }}
            </th>
            <th scope="col" class="w7per">
              {{ translate('sim_task_list.task_list.updated_at') }}
            </th>

          </tr>
        </thead>
        <tbody>
          <SimTaskListItem
              v-for="(sim_task,key) in sim_task_list"
              :key="key"
              :sim_task="sim_task"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TaskItem from "./Item/TaskItem.vue";
import CreateSimTask from "components/UIComponents/SimTask/CreateSimTask.vue";

export default {
  name: 'SimTaskList',
  components: {
    SimTaskListItem: TaskItem
  },
  data () {
    return {
      sim_task_list: [],
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      filter:{
        target_result: null,
        status: null
      }
    }
  },

  computed:{
    sended_filter(){
      let filter = []
      Object.keys(this.filter).forEach((item) => {
        if (this.filter[item] !== null && this.filter[item] !== undefined && this.filter[item] !== ""){
          filter[item] = this.filter[item]
        }
      })
      return filter
    },
    target_list(){
      return this.$store.getters.getSimTasks.results.map(item => {
        return {id: item.id, label: item.descr}
      })
    },

    status_list(){
      return this.$store.getters.getSimTasks.statuses.map(item => {
        return {id: item.id, label: item.descr}
      })
    },
  },

  watch:{

  },

  created () {
    this.get_sim_task_list()
  },

  methods: {
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_sim_task_list, 200)
    },
    create_sim_task(){
      let t = this.$createElement(CreateSimTask, {
        props: {},
        on: {
          close: () => {
            this.$modal.hide('create_sim_task')
          },
          update: () => {
            this.$modal.hide('create_sim_task')
            this.get_sim_task_list()
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'create_sim_task'
      })
    },
    get_sim_task_list(){
      this.$http.simcard.getSimTaskList(this.sended_filter, (response) => {
        if (response.data){
          this.sim_task_list = response.data
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },

    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>

.sim-task_list{
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .main_filters{
    top: 20px;
  }
  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .search_user{
        margin-bottom: 0;
        width: 100%;
      }
      .btn{
        width: 30%;
      }
    }
    .form_select{
      flex: 1;
      .vue-treeselect{
        margin-bottom: 0;
      }
    }
  }

  .response_table{
    flex: 10;
    padding-left: 0;
    padding-right: 0;
    th, td{
      font-size: 12px;
    }
  }
}

@media (max-width: 1200px) {
  .projects_list{
    .response_table{
      .w180{
        max-width: none;
        width: auto;
      }
      .w100{
        max-width: none;
        width: auto;
      }
    }
  }
}

@media (max-width: 500px){
  .header{
    .form{
      width: 100%;
      .filter{
        min-width: max-content;
        margin: 0 10px;
      }
    }
    .btn{
      b{
        display: none;
      }
      width: 20%;
      min-width: inherit;
    }
    .search_user{
      width: 80%;
    }
  }

}
</style>
